import { render, staticRenderFns } from "./EocVitalsV2Properties.vue?vue&type=template&id=3e0a4815&"
import script from "./EocVitalsV2Properties.vue?vue&type=script&lang=js&"
export * from "./EocVitalsV2Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports